import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { darkenHexColor } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

type TLButtonProps = React.ComponentProps<typeof Button> & {
  backgroundColor: string;
  textColor: string;
  invert?: boolean;
  tooltip?: string; // <-- optionnel
};

export function TLButton({
  backgroundColor,
  textColor,
  style,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  onMouseUp,
  invert = false,
  tooltip,
  ...props
}: TLButtonProps) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  const computeBackground = () => {
    if (pressed) return darkenHexColor(backgroundColor, !invert ? -20 : 20);
    if (hovered) return darkenHexColor(backgroundColor, !invert ? -10 : 10);
    return backgroundColor;
  };

  const buttonElement = (
    <Button
      variant="ghost"
      {...props}
      style={{
        backgroundColor: computeBackground(),
        color: textColor,
        ...style,
      }}
      onMouseEnter={(e) => {
        setHovered(true);
        onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setHovered(false);
        setPressed(false);
        onMouseLeave?.(e);
      }}
      onMouseDown={(e) => {
        setPressed(true);
        onMouseDown?.(e);
      }}
      onMouseUp={(e) => {
        setPressed(false);
        onMouseUp?.(e);
      }}
    />
  );

  // Si pas de tooltip → on retourne juste le bouton
  if (!tooltip) return buttonElement;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{buttonElement}</TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
